<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RBraZk/tc-custom/9781613120293.jpg?1727844071700" alt="This image is the cover for the book Struts & Frets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Struts & Frets
      </h1>
      <p class="bookDescription body article font2">
        <p>Music is in Sammy’s blood. His grandfather was a jazz musician, and Sammy’s indie rock band could be huge one day—if they don’t self-destruct first. Winning the upcoming Battle of the Bands would justify all the band’s compromises and reassure Sammy that his life’s dream could become a reality. But practices are hard to schedule when Sammy’s grandfather is sick and getting worse, his mother is too busy to help either of them, and his best friend may want to be his girlfriend. When everything in Sammy’s life seems to be headed for major catastrophe, will his music be enough to keep him together?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Skovron
      </h2>
      
      <p class="authorDescription body article">Jon Skovron is a music geek who can play nine instruments, but none of them well. This is his first novel. In his spare time, he writes technical manuals and tries to forget about his sordid past as an actor. He lives with his wife and two kids outside Washington, D.C. To learn more about him, the book, or the music, visit him at www.strutsandfretsbook.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a15ab97